import { apiFetch } from "@/client/lib/api";
import type { TicketPriority, TicketStatus } from "@/shared/ticket-status";

export interface TicketSummary {
  id: string;
  identifier: string;
  title: string;
  status: TicketStatus;
  createdAt: string;
  updatedAt: string;
}

export interface TicketComment {
  id: string;
  author: string;
  fromCustomer: boolean;
  body: string;
  createdAt: string;
}

export interface TicketDetail extends TicketSummary {
  description: string | null;
  comments: TicketComment[];
}

export interface CreateTicketInput {
  title: string;
  description: string;
  priority: TicketPriority;
}

export const ticketsApi = {
  list: () => apiFetch<{ tickets: TicketSummary[] }>("/tickets"),
  create: (input: CreateTicketInput) =>
    apiFetch<TicketSummary>("/tickets", { method: "POST", json: input }),
  get: (id: string) => apiFetch<TicketDetail>(`/tickets/${id}`),
  reply: (id: string, body: string) =>
    apiFetch<void>(`/tickets/${id}/comments`, { method: "POST", json: { body } }),
};
